module.exports = __webpack_public_path__ + "static/media/trash.1e392995.svg";


//////////////////
// WEBPACK FOOTER
// ./src/trash.svg
// module id = 423
// module chunks = 0